<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">

                <!-- Search bar -->
                <div class="row mb-3">
                    <div class="col-12 col-md-4">
                        <input v-model="searchQuery" type="text" class="form-control form-control-sm"
                            placeholder="&#xF002; Search categories..."
                            style="border-radius:8px; height: 40px; font-size: 14px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free'; font-weight: 900;">
                    </div>
                    <div class="col-12 col-md-8 d-flex align-items-center justify-content-end">
                        <small class="text-muted">{{ filteredSettings.length }} of {{ settingsList.length }} categories</small>
                    </div>
                </div>

                <!-- Categories Grid -->
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-12 mb-2" v-for="(item, index) in filteredSettings"
                        :key="index">
                        <div class="category-row">
                            <div class="category-label">
                                <span>{{ item.label }}</span>
                            </div>
                            <div class="btn-group" role="group">
                                <button type="button"
                                    class="btn btn-outline-left btn-sm rounded-start-pill btn-check-left hand-cursor"
                                    @click="ChangeSettings(item.key, 1)"
                                    :class="{ active: settings[item.key] == 1 }"
                                    :disabled="action_cooldowns[item.key]">Allow</button>

                                <button type="button"
                                    class="btn btn-outline-center btn-sm btn-check-center hand-cursor"
                                    @click="ChangeSettings(item.key, 0)"
                                    :class="{ active: settings[item.key] == 0 }"
                                    :disabled="action_cooldowns[item.key]">Off</button>

                                <button type="button"
                                    class="btn btn-outline-right btn-sm rounded-end-pill btn-check-right hand-cursor"
                                    @click="ChangeSettings(item.key, 2)"
                                    :class="{ active: settings[item.key] == 2 }"
                                    :disabled="action_cooldowns[item.key]">Block</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="filteredSettings.length === 0" class="text-center text-muted py-4">
                    No categories match your search.
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            settings: [],
            action_cooldowns: {},
            searchQuery: '',
            settingsList: [
                { key: 'abortion', label: 'Abortion' },
                { key: 'information_technology', label: 'Information Technology' },
                { key: 'adult_content', label: 'Adult Content' },
                { key: 'jobs_and_careers', label: 'Jobs & Careers' },
                { key: 'advertising', label: 'Advertising' },
                { key: 'malicious', label: 'Malicious' },
                { key: 'alcohol_and_tobacco', label: 'Alcohol & Tobacco' },
                { key: 'media_sharing', label: 'Media Sharing' },
                { key: 'blogs_and_personal_sites', label: 'Blogs & Personal Sites' },
                { key: 'message_boards_and_forums', label: 'Message Boards & Forums' },
                { key: 'business', label: 'Business' },
                { key: 'news_and_media', label: 'News & Media' },
                { key: 'chat_and_instant_messaging', label: 'Chat & Instant Messaging' },
                { key: 'parked_sites_and_domains', label: 'Parked Sites & Domains' },
                { key: 'content_servers', label: 'Content Servers' },
                { key: 'proxy_and_filter_avoidance', label: 'Proxy & Filter Avoidance' },
                { key: 'dating_and_personals', label: 'Dating & Personals' },
                { key: 'real_estate', label: 'Real Estate' },
                { key: 'deceptive', label: 'Deceptive' },
                { key: 'religion', label: 'Religion' },
                { key: 'drugs', label: 'Drugs' },
                { key: 'shopping', label: 'Shopping' },
                { key: 'economy_and_finance', label: 'Economy & Finance' },
                { key: 'search_engines_and_portals', label: 'Search Engines & Portals' },
                { key: 'education_and_self_help', label: 'Education & Self-help' },
                { key: 'social_networking', label: 'Social Networking' },
                { key: 'entertainment', label: 'Entertainment' },
                { key: 'streaming_media', label: 'Streaming Media' },
                { key: 'food_and_recipes', label: 'Food & Recipes' },
                { key: 'sports', label: 'Sports' },
                { key: 'gambling', label: 'Gambling' },
                { key: 'translation_sites', label: 'Translation Sites' },
                { key: 'games', label: 'Games' },
                { key: 'travel', label: 'Travel' },
                { key: 'hacking_and_cracking', label: 'Hacking & Cracking' },
                { key: 'uncategorized', label: 'Uncategorized' },
                { key: 'health', label: 'Health' },
                { key: 'vehicles', label: 'Vehicles' },
                { key: 'humor', label: 'Humor' },
                { key: 'virtual_reality', label: 'Virtual Reality' },
                { key: 'illegal_content', label: 'Illegal Content' },
                { key: 'weapons', label: 'Weapons' }
            ]
        };
    },

    computed: {
        filteredSettings() {
            if (!this.searchQuery) return this.settingsList;
            const q = this.searchQuery.toLowerCase();
            return this.settingsList.filter(item => item.label.toLowerCase().includes(q));
        }
    },

    mounted() {
        this.init();
        this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-settings")
            .then((response) => {
                this.settings = response.data.settings
            })
            .catch((error) => {
                console.log(error)
            })
    },

    methods: {
        init() { },

        setCooldown(key) {
            if (typeof this.$set === 'function') {
                this.$set(this.action_cooldowns, key, true);
                setTimeout(() => {
                    this.$delete(this.action_cooldowns, key);
                }, 1000);
            } else {
                this.action_cooldowns[key] = true;
                setTimeout(() => {
                    delete this.action_cooldowns[key];
                }, 1000);
            }
        },

        async ChangeSettings(column_name, value) {
            if (this.action_cooldowns[column_name]) return;

            const columnNameCurrentValue = this.settings[column_name];
            if (columnNameCurrentValue == value) return;

            this.setCooldown(column_name);
            this.settings[column_name] = value;

            let payload = {
                "settings_column": column_name,
                "settings_value": this.settings[column_name]
            }

            const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-setting", payload)
            if (resp.data.success != null && resp.data.success == false) {
                this.$toast.error(resp.data.message)
            } else {
                this.$toast.success(resp.data.message + " Please note: It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.")
            }
        }
    }
}
</script>

<style scoped>
.card {
    border: none;
}

/* Category row layout */
.category-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    border-radius: 8px;
    transition: background-color 0.15s ease;
}

.category-row:hover {
    background-color: #f8f9fa;
}

.category-label {
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
}

/* Button group styles */
.btn-check-left { min-width: 5rem; max-height: 2.2rem; border-color: gray; }
.btn-check-center { min-width: 3.5rem; max-height: 2.2rem; border-color: gray; }
.btn-check-right { min-width: 5rem; max-height: 2.2rem; border-color: gray; }

.btn-outline-right { color: #f3994d; background-color: transparent; border-color: grey }
.btn-outline-right:hover, .btn-outline-right.active, .btn-outline-right:active { color: whitesmoke; background-color: #f3994d; border-color: #f3994d; font-weight: bold;}

.btn-outline-center { color: #a3c0d1; background-color: transparent; border-color: grey }
.btn-outline-center:hover, .btn-outline-center.active, .btn-outline-center:active { color: whitesmoke; background-color: #a3c0d1; border-color: #a3c0d1; font-weight: bold;}

.btn-outline-left { color: #00a0c1; background-color: transparent; border-color: grey }
.btn-outline-left:hover, .btn-outline-left.active, .btn-outline-left:active { color: whitesmoke; background-color: #00a0c1; border-color: #00a0c1; font-weight: bold;}

.hand-cursor {
    cursor: pointer;
}
</style>